<template>
  <v-div
    class="DataLayout"
    :border-softened-top="showBorder"
    clear-fix
    :overflow-hidden="overflowHidden"
  >
    <v-div
      v-if="isDestructive"
      float-right
      :width-100-minus-256="displayIsTablet || displayIsDesktop"
      :width-100-percent="displayIsMobile"
      mb-2
    >
      <slot></slot>
    </v-div>

    <fieldset v-else-if="isFieldset">
      <v-div
        class="float-left pr-3"
        :style="displayIsMobile ? 'width: 100%;' : 'width: 256px;'"
      >
        <v-div subtitle-1>
          <legend>{{ title }}</legend>
          <Toggletip
            v-if="information"
            :width="250"
            :activator-label="informationLabel"
            >{{ information }}</Toggletip
          >
        </v-div>
        <v-div v-if="subTitle" caption>{{ subTitle }}</v-div>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="instructions"
          :id="instructionId"
          class="caption"
          v-html="instructions"
        />
        <!-- eslint-enable vue/no-v-html -->
      </v-div>
      <v-div
        class="float-left mb-2"
        :style="displayIsMobile ? 'width: 100%;' : 'width: calc(100% - 256px);'"
      >
        <slot></slot>
      </v-div>
    </fieldset>

    <template v-else>
      <component
        :is="isDl ? 'dt' : 'v-div'"
        class="float-left pt-4 pr-3"
        :style="displayIsMobile ? 'width: 100%;' : 'width: 256px;'"
      >
        <v-div subtitle-1>
          <span>{{ title }}</span>
          <Toggletip
            v-if="information"
            :width="250"
            :activator-label="informationLabel"
            >{{ information }}</Toggletip
          >
        </v-div>
        <v-div v-if="subTitle" caption>{{ subTitle }}</v-div>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="instructions"
          :id="instructionId"
          class="caption"
          v-html="instructions"
        />
        <!-- eslint-enable vue/no-v-html -->
      </component>
      <component
        :is="isDl ? 'dd' : 'v-div'"
        class="float-left"
        :style="displayIsMobile ? 'width: 100%;' : 'width: calc(100% - 256px);'"
      >
        <slot></slot>
      </component>
    </template>
  </v-div>
</template>

<script>
import { mapState } from "vuex";
import Toggletip from "~/components/page/components/toggletip/Toggletip.vue";
import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

export default {
  name: "DataLayout",
  components: { Toggletip },
  props: {
    title: { type: String, default: "" },
    subTitle: { type: String, default: "" },
    information: { type: String, default: undefined },
    informationLabel: { type: String, default: undefined },
    instructions: { type: String, default: undefined },
    instructionId: { type: String, default: null },
    isFieldset: { type: Boolean, default: false },
    overflowHidden: { type: Boolean, default: false },
    showInformation: { type: Boolean, default: false },
    isDestructive: { type: Boolean, default: false },
    showBorder: { type: Boolean, default: false },
    isDl: { type: Boolean, default: false },
  },
  data() {
    return {
      displayInformation: false,
      showTooltip: false,
    };
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
    }),
    displayIsMobile,
    displayIsTablet,
    displayIsDesktop,
    primaryTitle() {
      return this.layout.dataLayoutPrimaryTitle;
    },
  },
  mounted() {
    if (this.showInformation) {
      this.displayInformation = this.showInformation;
    }
  },
};
</script>

<style>
.DataLayout .info-button {
  vertical-align: top;
  text-align: center;
  margin-top: -4px;
}
</style>
